<template>
  <div
    data-qa="lpu_logo"
    class="lpu-logo bg-gray-0 overflow-hidden"
  >
    <img
      v-if="lpu.closed"
      data-qa="lpu_logo_image"
      class="lpu-logo__image"
      :alt="`${tDynamic(lpu, 'name')}, ${tDynamic(lpu.town, 'name')} - ${tStatic('фото', 'global')}`"
      src="/static/_v1/pd/pictures/stubs/does-not-work-240x80.svg"
      :title="`${tDynamic(lpu, 'name')}, ${tDynamic(lpu.town, 'name')}`"
    >
    <LpuLogoPicture
      v-else-if="ff_update_lpu_logo"
      img-class="lpu-logo__image"
      data-qa="lpu_logo_image"
      contain
      :files="getLpuLogoImageFiles(lpu)"
      :alt="`${tDynamic(lpu, 'name')}, ${tDynamic(lpu.town, 'name')} - ${tStatic('фото', 'global')}`"
      :title="`${tDynamic(lpu, 'name')}, ${tDynamic(lpu.town, 'name')}`"
    />
    <img
      v-else
      data-qa="lpu_logo_image"
      class="lpu-logo__image"
      :alt="`${tDynamic(lpu, 'name')}, ${tDynamic(lpu.town, 'name')} - ${tStatic('фото', 'global')}`"
      :src="getLpuAvatarUrl({ lpu, isLarge: true })"
      :title="`${tDynamic(lpu, 'name')}, ${tDynamic(lpu.town, 'name')}`"
    >
  </div>
</template>

<script lang="ts" setup>
import transStatic from 'djanjucks/filters/transStatic'
import { computed } from 'vue'
import type { CommonContextStore } from 'src/types/context'
import useContextStore from 'src/store/useContextStore'
import getLpuAvatarUrl, { getLpuLogoImageFiles } from 'src/utils/getLpuAvatarUrl'
import LpuLogoPicture from 'src/components/common/LpuLogoPicture/LpuLogoPicture.vue'
import tDynamic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tDynamic'
import type { Lpu } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'

defineProps<{
  lpu: Lpu
}>()

const { context }: CommonContextStore = useContextStore()
const ff_update_lpu_logo = computed(() => Boolean(context.request.feature_flags.ff_update_lpu_logo))

function tStatic(text: string, tContext: string) {
  return transStatic(context.need_translate, `${text},${tContext}`)
}
</script>

<style lang="scss" scoped>
@import 'src/styles/breakpoints';

.lpu-logo {
  width: 220px;
  height: 80px;
  border-radius: 20px;
  padding: 16px;
  box-shadow: 0 1.23px 2.46px 0 rgba(5, 23, 40, 0.08),
    0 0 2.46px 0 rgba(21, 40, 92, 0.06),
    0 2.46px 29.5px 0 rgba(9, 42, 72, 0.08);

  @include media-down('sm') {
    width: 145px;
    height: 52px;
    border-radius: 15px;
    padding: 10px;
  }

  &__image {
    width: 100%;
    max-height: 100%;
    aspect-ratio: 3 / 1;
    object-fit: contain;
  }

  :deep(img) {
    width: 100%;
    max-height: 100%;
    aspect-ratio: 3 / 1;
    object-fit: contain;
  }
}
</style>
